<template>
  <div
    v-if="display"
    :class="[
      'flex border-b border-gray-200 hover:bg-gray-50 focus:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500 transition-colors cursor-pointer',
      { 'bg-gray-50/50': stripe },
    ]"
    tabindex="0"
    role="button"
    @dblclick="$emit('dblclick')"
    @keydown.enter.prevent="$emit('dblclick')"
    @keydown.space="handleSpaceKey"
  >
    <div class="w-1/3 px-4 py-3 flex items-center">
      {{ label }}
    </div>
    <div class="w-1/3 px-4 py-3" :data-testid="dataTestid">
      <slot v-if="isEditing" name="input" />
      <template v-else>
        <slot name="display" />
      </template>
    </div>
    <div class="w-1/3 px-4 py-3 flex items-center">
      {{ lastUpdated }}
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label: string;
  lastUpdated?: string;
  display: boolean;
  isEditing: boolean;
  stripe?: boolean;
  dataTestid?: string;
}>();

const emit = defineEmits<{
  dblclick: [];
}>();

const handleSpaceKey = (event: KeyboardEvent) => {
  const target = event.target as HTMLElement;
  const tagName = target.tagName.toLowerCase();
  const isRowActivationForAccessibility =
    tagName !== "input" && tagName !== "textarea";

  if (isRowActivationForAccessibility) {
    event.preventDefault();
    emit("dblclick");
  }
};
</script>
